import { render, staticRenderFns } from "./InfoIntegration.vue?vue&type=template&id=4d8db142&scoped=true"
import script from "./InfoIntegration.vue?vue&type=script&lang=js"
export * from "./InfoIntegration.vue?vue&type=script&lang=js"
import style0 from "./InfoIntegration.vue?vue&type=style&index=0&id=4d8db142&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8db142",
  null
  
)

export default component.exports